<template>
    <div class="overflow-y-auto h-screen-header">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="tabs tabs-boxed mb-2 bg-base-100 !flex">
                <div class="flex justify-between w-full">
                    <div>
                        <a v-for="{ value, text } in options" :key="value"
                            :class="{ 'tab': true, 'tab-active': sortValue === value }">
                            <router-link :to="{ 'path': '/playlists/' + value }">
                                {{ text }}
                            </router-link>
                        </a>
                    </div>
                    <div>
                        <button class="btn btn-sm mr-1" @click="handleImportPlayList">{{ $tt('导入歌单') }}</button>
                        <button class="btn btn-sm" @click="handleAiPlayList">{{ $tt('智能歌单') }}</button>
                        <dialog id="ai-list" ref="ai-list" class="modal">
                            <div class="modal-box md:overflow-y-visible w-2/3 max-w-5xl">
                                <h3 class="text-lg font-bold">{{ $tt('创建智能播放列表') }}</h3>
                                <div class="py-4 z-20">
                                    <div class="mb-2">
                                        <span>{{ $tt('列表名称：') }}</span>
                                        <input type="text" :placeholder="$tt('请输入播放列表名称')"
                                            class="input input-bordered input-sm w-full max-w-xs"
                                            v-model="playlistName" />
                                    </div>
                                    <div v-for="(item, index) in conditions" :key="'a' + index">
                                        <div class="flex items-center">
                                            <div v-if="index === 0">{{ $tt('满足条件') }}</div>
                                            <div v-else>
                                                <div class="btn btn-sm">{{ $tt('或') }}</div>
                                                {{ $tt('满足条件') }}
                                            </div>
                                            <div class="ml-2 flex">
                                                <button class="btn btn-square btn-outline btn-sm mr-1"
                                                    @click="addItem">+</button>
                                                <button class="btn btn-square btn-outline btn-sm"
                                                    @click="removeItem(index)" v-if="conditions.length > 1">-</button>
                                            </div>
                                        </div>
                                        <div class="flex mt-2 ml-6 items-center" v-for="(sub, subIndex) in item"
                                            :key="'s' + index + 'a' + subIndex">
                                            <div v-if="subIndex >= 1" class="mr-1 btn btn-sm">{{ $tt('且') }}</div>
                                            <single-select
                                                v-model="sub.key"
                                                :options="keyOptions"
                                                class="mr-1"
                                            />
                                            <single-select
                                                v-if="boolKeyList.indexOf(sub.key) !== -1"
                                                v-model="sub.operate"
                                                :options="operateOptions"
                                                class="mr-1"
                                            />
                                            <single-select
                                                v-else-if="numberKeyList.indexOf(sub.key) !== -1"
                                                v-model="sub.operate"
                                                :options="operateGteOptions"
                                                class="mr-1"
                                            />
                                            <single-select
                                                v-else
                                                v-model="sub.operate"
                                                :options="valueOptions"
                                                class="mr-1"
                                            />
                                            <select class="select select-bordered select-sm w-full max-w-xs"
                                                v-if="boolKeyList.indexOf(sub.key) !== -1" v-model="sub.value">
                                                <option value="">True</option>
                                            </select>
                                            <div class="w-full max-w-xs flex items-center"
                                                v-else-if="numberKeyList.indexOf(sub.key) !== -1">
                                                <input type="number" :placeholder="$tt('请输入')"
                                                    class="input input-bordered input-sm w-full max-w-xs"
                                                    v-model="sub.value" />
                                                <div class="ml-2" v-if="sub.key === 'bit-rate'">kps</div>
                                                <div class="ml-2" v-else-if="sub.key === 'size'">MB</div>
                                                <div class="ml-2" v-else-if="['play-count', 'album-play-count', 'artist-play-count'].includes(sub.key)">{{ $tt('次') }}</div>
                                                <div class="ml-2" v-else-if="sub.key === 'year'">{{ $tt('年') }}</div>
                                                <div class="ml-2" v-else-if="sub.key === 'duration'">{{ $tt('秒') }}</div>
                                                <div class="ml-2" v-else-if="sub.key === 'accessed-date'">{{ $tt('天') }}</div>
                                                <div class="ml-2" v-else-if="sub.key === 'created-at'">{{ $tt('天') }}</div>
                                                <div class="ml-2" v-else-if="sub.key === 'cover-width'">px</div>
                                                <div class="ml-2" v-else-if="sub.key === 'cover-height'">px</div>
                                                <div v-else></div>
                                            </div>
                                            <div class="w-full max-w-xs" v-else>
                                                <input type="text" :placeholder="$tt('请输入')"
                                                    class="input input-bordered input-sm w-full max-w-xs"
                                                    v-model="sub.value" />
                                            </div>
                                            <div class="ml-2 flex">
                                                <button class="btn btn-square btn-outline btn-sm mr-1"
                                                    @click="addSubItem(index)">+</button>
                                                <button class="btn btn-square btn-outline btn-sm"
                                                    @click="removeSubItem(index, subIndex)"
                                                    v-if="item.length > 1">-</button>
                                            </div>
                                        </div>
                                        <div class="divider"
                                            v-if="conditions.length > 1 && conditions.length !== index + 1">OR</div>
                                    </div>
                                    <div class="flex mt-4 items-center">
                                        <div class="w-8 mr-1">{{ $tt('最多') }}</div>
                                        <input type="number" min="1" :placeholder="$tt('请输入')"
                                            class="input input-bordered input-sm w-16 max-w-xs mr-1" v-model.number="limit" />
                                        <select class="select select-bordered select-sm w-16 max-w-xs mr-2"
                                            v-model="unit">
                                            <option value="item">{{ $tt('项') }}</option>
                                        </select>
                                        <div class="w-16 mr-1">{{ $tt('选择标准') }}</div>
                                        <single-select
                                            v-model="selectStandard"
                                            :options="selectStandardOptions"
                                        />
                                    </div>
                                    <div class="form-control w-24">
                                        <label class="cursor-pointer label">
                                            <input type="checkbox" class="checkbox checkbox-secondary"
                                                v-model="isDynamic" />
                                            <span class="label-text">{{ $tt('动态更新') }}</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="modal-action">
                                    <form method="dialog">
                                        <button class="btn btn-neutral btn-sm mr-2" @click="handleCreate">{{ $tt('确认') }}</button>
                                        <button class="btn btn-sm">{{ $tt('取消') }}</button>
                                    </form>
                                </div>
                            </div>
                        </dialog>
                        <dialog ref="import-list" class="modal">
                            <div class="modal-box">
                                <form method="dialog">
                                    <button class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2" :disabled="isImportingPlaylist">✕</button>
                                </form>
                                <h3 class="font-bold text-lg mb-4">{{ $tt('导入播放列表') }}</h3>
                                <div class="text-gray-400 mb-2">
                                    {{ $tt('导入一个播放列表，支持 m3u8 文件。') }}
                                </div>
                                <!-- <div class="mb-2">
                                    <span>{{ $tt('列表名称：') }}</span>
                                    <input type="text" :placeholder="$tt('请输入播放列表名称')" class="input input-bordered input-sm w-full max-w-xs" v-model="playlistName" />
                                </div> -->
                                <!-- <div role="tablist" class="tabs tabs-boxed w-80 mb-2"> -->
                                <!-- <a role="tab" class="tab tab-active">{{ $tt('文件导入') }}</a> -->
                                <!-- <a role="tab" class="tab">{{ $tt('网易云歌单') }}</a> -->
                                <!-- <a role="tab" class="tab">{{ $tt('QQ音乐歌单') }}</a> -->
                                <!-- </div> -->
                                <input ref="playlist-file-input" type="file" class="file-input file-input-bordered file-input-sm w-full max-w-xs"
                                    :disabled="isImportingPlaylist"
                                    @change="onFileChange" />
                                <div class="form-control w-full mt-4">
                                    <label class="cursor-pointer label">
                                        <span class="label-text">{{ $tt('替换歌曲路径前缀') }}</span>
                                        <input type="checkbox" class="checkbox checkbox-secondary" v-model="replaceTrackPath" :disabled="isImportingPlaylist" />
                                    </label>
                                </div>
                                <div v-if="replaceTrackPath" class="form-control w-full mt-2">
                                    <label class="label">
                                        <span class="label-text">{{ $tt('原始路径前缀 (要被替换的部分)') }}</span>
                                    </label>
                                    <input type="text" :placeholder="$tt('例如: /old/music/path/ 或 C:\\Music\\')" 
                                           class="input input-bordered input-sm w-full" 
                                           :disabled="isImportingPlaylist"
                                           v-model="originalPathPrefix" />
                                    <label class="label">
                                        <span class="label-text-alt text-gray-500">{{ $tt('将替换为系统音乐库路径，保留相对路径结构') }}</span>
                                    </label>
                                </div>
                                <div class="modal-action">
                                    <button class="btn btn-sm btn-neutral" :disabled="isImportingPlaylist || !selectedFile" @click="uploadFile">
                                        <span v-if="isImportingPlaylist" class="loading loading-spinner loading-xs"></span>
                                        {{ isImportingPlaylist ? $tt('导入中...') : $tt('保存') }}
                                    </button>
                                    <form method="dialog">
                                        <!-- if there is a button in form, it will close the modal -->
                                        <button class="btn btn-sm" :disabled="isImportingPlaylist">{{ $tt('取消') }}</button>
                                    </form>
                                </div>
                            </div>
                        </dialog>
                    </div>
                </div>

            </div>
        </div>
        <Tiles v-if="playlist.length > 0">
            <div
                v-for="(item, index) in playlist"
                :key="item.id"
                :class="index < 15 ? 'tile-animate-in' : ''"
                :style="index < 15 ? { 'animation-delay': `${index * 0.1}s` } : {}"
                style="display: contents;"
            >
                <Tile
                    :image="item.image"
                    :to="{ name: 'playlist', params: { id: item.id } }" :title="item.name" :square="false" :small="false"
                    :allow-h-scroll="false">
                    <template #text>
                        <router-link :to="{ name: 'playlist', params: { id: item.id } }">
                            <strong>{{ item.trackCount }}</strong> {{ $tt('歌曲') }}
                        </router-link>
                    </template>
                    <template #play>
                        <div class="absolute top-[43%] z-10 left-[39%] play-icon cursor-pointer" @click="playNow(item.id)">
                            <svg class="fill-purple-800 w-12 h-12 hover:fill-purple-600" viewBox="0 0 1024 1024"
                                version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2415" width="32" height="32">
                                <path
                                    d="M512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024zM383.232 287.616v448l384-223.104-384-224.896z"
                                    p-id="2416"></path>
                            </svg>
                        </div>
                    </template>
                </Tile>
            </div>
        </Tiles>
    </div>
</template>
<script>
import Tiles from '@/components/library/Tiles'
import Tile from '@/components/library/Tile'
import SingleSelect from '@/components/iview/SingleSelect'
export default {
    name: 'playlists',
    components: {
        Tiles, Tile, SingleSelect
    },
    props: {
    },
    data() {
        return {
            options: [
                { text: this.$tt('最近添加'), value: 'recently-added' },
                { text: this.$tt('A-Z排序'), value: 'a-z' }
            ],
            playlist: [],
            playlistName: '',
            limit: 25,
            unit: 'item',
            selectStandard: '?',
            isDynamic: false,
            showAddModal: false,
            conditions: [[
                { 'key': 'favourite-track', 'operate': 'is', 'value': '' }
            ]],
            boolKeyList: ['favourite-track', 'favourite-album', 'favourite-artist', 'album-img', 'artist-img'],
            numberKeyList: ['play-count', 'album-play-count', 'artist-play-count', 'sample-rate', 'bit-rate', 'size', 'year', 'duration', 'accessed-date',
                'created-at', 'rating', 'cover-width', 'cover-height'],
            selectedFile: null,
            replaceTrackPath: false,
            originalPathPrefix: '',
            isImportingPlaylist: false,
            keyOptions: [
                { id: 'favourite-track', name: this.$tt('标记为喜爱的歌曲') },
                { id: 'favourite-album', name: this.$tt('标记为喜爱的专辑') },
                { id: 'favourite-artist', name: this.$tt('标记为喜爱的艺术家') },
                { id: 'rating', name: this.$tt('评分') },
                { id: 'file-path', name: this.$tt('文件路径') },
                { id: 'title', name: this.$tt('标题') },
                { id: 'album', name: this.$tt('专辑') },
                { id: 'artist', name: this.$tt('艺术家') },
                { id: 'genre', name: this.$tt('流派') },
                { id: 'comment', name: this.$tt('描述') },
                { id: 'lyrics', name: this.$tt('歌词') },
                { id: 'language', name: this.$tt('语言') },
                { id: 'label', name: this.$tt('标签') },
                { id: 'play-count', name: this.$tt('播放次数') },
                { id: 'album-play-count', name: this.$tt('专辑播放次数') },
                { id: 'artist-play-count', name: this.$tt('艺术家播放次数') },
                { id: 'bit-rate', name: this.$tt('比特率') },
                { id: 'size', name: this.$tt('大小') },
                { id: 'year', name: this.$tt('年份') },
                { id: 'duration', name: this.$tt('时长') },
                { id: 'accessed-date', name: this.$tt('距离最近播放') },
                { id: 'created-at', name: this.$tt('距离最近添加') },
                { id: 'album-img', name: this.$tt('专辑图片') },
                { id: 'artist-img', name: this.$tt('艺术家图片') },
                { id: 'cover-width', name: this.$tt('封面宽度') },
                { id: 'cover-height', name: this.$tt('封面高度') },
            ],
            operateOptions: [
                { id: 'is', name: this.$tt('是') },
                { id: 'not', name: this.$tt('不是') },
            ],
            operateGteOptions: [
                { id: 'gte', name: this.$tt('大于') },
                { id: 'lte', name: this.$tt('小于') },
                { id: 'is', name: this.$tt('是') },
                { id: 'not', name: this.$tt('不是') },
            ],
            valueOptions: [
                { id: 'contain', name: this.$tt('包含') },
                { id: 'not_contain', name: this.$tt('不包含') },
                { id: 'startwith', name: this.$tt('开头是') },
                { id: 'endwith', name: this.$tt('结尾是') },
                { id: 'is', name: this.$tt('是') },
                { id: 'not', name: this.$tt('不是') },
            ],
            selectStandardOptions: [
                { id: '?', name: this.$tt('随机') },
                { id: '-accessed_date', name: this.$tt('最近播放') },
                { id: 'accessed_date', name: this.$tt('最早播放') },
                { id: '-plays_count', name: this.$tt('最常播放') },
                { id: 'plays_count', name: this.$tt('最少播放') },
                { id: '-created_at', name: this.$tt('最近添加') },
                { id: 'created_at', name: this.$tt('最早添加') },
            ]
        }
    },
    computed: {
        sortValue: {
            get() {
                return this.$route.params.sort
            }
        }
    },
    watch: {
        // sortValue: {
        //     async handler() {
        //         this.playlist = await this.$api.subsonic.getPlaylists(this.sortValue)
        //     }
        // }
    },
    async created() {
        this.playlist = await this.$api.subsonic.getPlaylists(this.sortValue)
    },
    methods: {
        async refreshPlaylists() {
            this.playlist = await this.$api.subsonic.getPlaylists(this.sortValue)
        },
        resetImportForm() {
            this.selectedFile = null
            this.replaceTrackPath = false
            this.originalPathPrefix = ''
            if (this.$refs['playlist-file-input']) {
                this.$refs['playlist-file-input'].value = ''
            }
        },
        async playNow(id) {
            const playlist = await this.$api.subsonic.getPlaylist(id)
            return this.$store.dispatch('playTrackList', {
                tracks: playlist.tracks
            })
        },
        handleAiPlayList() {
            this.$refs["ai-list"].showModal()
        },
        handleImportPlayList() {
            this.resetImportForm()
            this.$refs["import-list"].showModal()
        },
        addSubItem(index) {
            this.conditions[index].push({ 'key': '', 'operate': '', 'value': '' })
        },
        removeSubItem(index, subIndex) {
            if (this.conditions[index].length > 1) {
                this.conditions[index].splice(subIndex, 1)
            }
        },
        addItem() {
            this.conditions.push([{ 'key': '', 'operate': '', 'value': '' }])
        },
        removeItem(index) {
            this.conditions.splice(index, 1)
        },
        handleCreate() {
            if (!this.playlistName) {
                this.$myMsg.notify({
                    title: this.$tt('警告！'),
                    content: this.$tt('播放列表名称不能为空！'),
                    type: 'warning',
                    time: 2000,
                })
                return
            }
            this.$api.subsonic.createPlaylistAi(this.playlistName,
                JSON.stringify(this.conditions), this.limit, this.selectStandard, this.isDynamic).then(() => {
                    this.$myMsg.notify({
                        title: this.$tt('添加成功！'),
                        type: 'success',
                        time: 2000,
                    })
                    this.$refs["ai-list"].close()
                    this.$api.subsonic.getPlaylists(this.sortValue).then((res) => {
                        this.playlist = res
                    })

                })
        },
        onFileChange(event) {
            this.selectedFile = event.target.files[0] || null
        },
        async uploadFile() {
            if (this.isImportingPlaylist) {
                return
            }
            if (!this.selectedFile) {
                this.$myMsg.notify({
                    title: this.$tt('警告！'),
                    content: this.$tt('请先选择歌单文件！'),
                    type: 'warning',
                    time: 2000,
                })
                return
            }

            const formData = new FormData()
            formData.append('file', this.selectedFile)
            formData.append('replace_path', this.replaceTrackPath)
            if (this.replaceTrackPath && this.originalPathPrefix) {
                formData.append('original_path_prefix', this.originalPathPrefix)
            }

            this.isImportingPlaylist = true
            try {
                const res = await this.$api.Task.importPlaylist(formData)
                if (res.result) {
                    const data = res.data || {}
                    const statistics = data.statistics || {
                        found_tracks: 0,
                        total_tracks: 0,
                        success_rate: 0
                    }
                    const warnings = data.warnings || null
                    let title = this.$tt('导入成功！')
                    let content = this.$tt('成功导入 {found}/{total} 首歌曲 (成功率: {rate}%)', {
                        found: statistics.found_tracks,
                        total: statistics.total_tracks,
                        rate: statistics.success_rate
                    })
                    let type = 'success'
                    
                    // 路径替换相关信息
                    if (data.path_replacement && data.path_replacement.enabled) {
                        const replacement = data.path_replacement
                        content += '\n' + this.$tt('路径替换: {count} 个文件', {
                            count: replacement.replaced_count
                        })
                        content += '\n' + this.$tt('替换规则: {from} → {to}', {
                            from: replacement.original_prefix,
                            to: replacement.target_prefix
                        })
                        
                        // 如果有缺失文件，显示警告
                        if (warnings && warnings.total_missing > 0) {
                            type = 'warning'
                            title = this.$tt('导入完成但有警告！')
                            content += '\n' + this.$tt('警告: {count} 个文件在替换路径下未找到', {
                                count: warnings.total_missing
                            })
                            
                            // 显示部分缺失文件列表
                            if (warnings.missing_files.length > 0) {
                                const missingList = warnings.missing_files
                                    .slice(0, 3)
                                    .map(file => file.relative_path || file.filename)
                                    .join(', ')
                                content += '\n' + this.$tt('缺失文件示例: {files}', { files: missingList })
                                if (warnings.total_missing > 3) {
                                    content += ' ' + this.$tt('等 {count} 个文件', {
                                        count: warnings.total_missing
                                    })
                                }
                            }
                        }
                    }
                    
                    this.$myMsg.notify({
                        title: title,
                        content: content,
                        type: type,
                        time: 4000,
                    })
                    this.resetImportForm()
                    this.$refs["import-list"].close()
                    await this.refreshPlaylists()
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('导入失败！'),
                        content: res.message,
                        type: 'error',
                        time: 2000,
                    })
                }
            } catch (error) {
                this.$myMsg.notify({
                    title: this.$tt('导入失败！'),
                    content: error?.message || this.$tt('导入请求失败，请稍后重试'),
                    type: 'error',
                    time: 2000,
                })
            } finally {
                this.isImportingPlaylist = false
            }
        }
    }
}
</script>
<style>
.play-icon {
    display: none;
}
.tile-img:hover .play-icon {
    display: block;
}

/* 动画应用到 Tile 组件内部的 .group 元素 */
.tile-animate-in + * .group {
    opacity: 0;
    animation: tileFadeIn 0.5s ease-out forwards !important;
    animation-delay: inherit !important;
}

/* 动画关键帧 */
@keyframes tileFadeIn {
    0% {
        opacity: 0;
        transform: translateY(20px) scale(0.9);
    }
    100% {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}
</style>
